import Component from './abstract_component';

class ChatbaseTrigger extends Component {
  constructor() {
    super();
    this.triggers = document.querySelectorAll('.js-chatbase-trigger > a');
  }

  _isReady() {
    return !!this.triggers.length;
  }

  _run() {
    this.triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        document.getElementById('chatbase-bubble-button').click();
      });
    })
  }
}

export default ChatbaseTrigger;
